import { jsx as y, Fragment as $, jsxs as Ae } from "react/jsx-runtime";
import { createContext as pe, useState as Me, useContext as P, useMemo as S, useRef as Ie, useEffect as Ce, useId as Le } from "react";
import n, { z as a } from "zod";
import { JsonLd as D } from "react-schemaorg";
import { useEffectOnce as Fe } from "@made-people/react-use-effect-once";
import { isProductMediaImage as xe } from "@made-people/grease-product";
const Ue = n.object({
  "@type": n.literal("BreadcrumbList"),
  itemListElement: n.array(
    n.object({
      "@type": n.literal("ListItem"),
      position: n.number(),
      item: n.object({
        name: n.string(),
        "@id": n.string()
      })
    })
  )
}), ze = Ue;
function Ne(e) {
  const t = ze.safeParse(e);
  return t.success, t.success;
}
var k = /* @__PURE__ */ ((e) => (e.FAQPage = "FAQPage", e.Product = "Product", e.ProductList = "ProductList", e.MerchantReturnPolicy = "MerchantReturnPolicy", e.ShippingRateSettings = "ShippingRateSettings", e.WebSite = "WebSite", e))(k || {});
const Ee = {
  structuredDataScripts: {},
  addToScripts: () => {
  },
  removeFromScripts: () => {
  }
}, N = pe(Ee), Ve = ({
  children: e
}) => {
  const [t, i] = Me({}), s = (c, o) => {
    c in t && typeof t[c] < "u" && console.info(
      "Structured data script already exists, overwriting it...",
      c
    ), i({ ...t, [c]: o });
  }, u = (c) => {
    if (!(c in t))
      return;
    const { [c]: o, ...r } = t;
    i(r);
  };
  return /* @__PURE__ */ y(
    N.Provider,
    {
      value: {
        structuredDataScripts: t,
        addToScripts: s,
        removeFromScripts: u
      },
      children: e
    }
  );
}, We = () => {
  const { structuredDataScripts: e } = P(N);
  return e;
}, Qe = () => {
  const { addToScripts: e } = P(N);
  return e;
}, Yt = () => {
  const { removeFromScripts: e } = P(N);
  return e;
}, w = pe(void 0), Zt = (e) => {
  const t = {
    mappers: e.mappers,
    pdpProduct: e.pdpProduct,
    context: e.context,
    offerShippingDetailsSettings: e.offerShippingDetailsSettings,
    merchantReturnPolicySettings: e.merchantReturnPolicySettings,
    breadCrumbs: e.breadCrumbs
  };
  return /* @__PURE__ */ y(w.Provider, { value: t, children: /* @__PURE__ */ y(Ve, { children: e.children }) });
}, en = () => {
  const e = P(w);
  if (e === void 0)
    throw new Error(
      "useStructuredDataMappers must be used within a StructuredDataProvider"
    );
  return e.mappers;
}, $e = () => {
  const e = P(w);
  if (e === void 0)
    throw new Error(
      "usePdpProduct must be used within a StructuredDataProvider"
    );
  return e.pdpProduct;
}, R = () => {
  const e = P(w);
  if (e === void 0)
    throw new Error(
      "useStructuredDataContext must be used within a StructuredDataProvider"
    );
  return e.context;
}, qe = () => {
  const e = P(w);
  if (e === void 0)
    throw new Error(
      "useShippingDetailsSettings must be used within a StructuredDataProvider"
    );
  return e.offerShippingDetailsSettings;
}, Be = () => {
  const e = P(w);
  if (e === void 0)
    throw new Error(
      "useBreadCrumbs must be used within a StructuredDataProvider"
    );
  return e.breadCrumbs;
}, He = () => {
  const e = P(w);
  if (e === void 0)
    throw new Error(
      "useMerchantReturnPolicySettings must be used within a StructuredDataProvider"
    );
  return e.merchantReturnPolicySettings;
}, Ge = () => {
  const e = Be(), { baseUrl: t, siteSlug: i } = R(), s = S(() => {
    if (typeof e > "u" || typeof t > "u" || typeof i > "u")
      return;
    const u = {
      "@type": "BreadcrumbList",
      itemListElement: e.map((c, o) => {
        const r = c.slug === "" ? c.slug : `/${c.slug}`;
        return {
          "@type": "ListItem",
          position: o,
          item: {
            name: c.label,
            "@id": `${t}/${i}${r}`
          }
        };
      })
    };
    if (Ne(u))
      return u;
  }, [e, t]);
  return typeof s > "u" ? null : /* @__PURE__ */ y(
    D,
    {
      item: {
        "@context": "https://schema.org",
        ...s
      }
    }
  );
}, _e = n.enum([
  "BackOrder",
  "Discontinued",
  "InStock",
  "InStoreOnly",
  "LimitedAvailability",
  "OnlineOnly",
  "OutOfStock",
  "PreOrder",
  "PreSale",
  "SoldOut"
]), q = _e;
function tn(e) {
  const t = q.safeParse(e);
  return t.success, t.success;
}
const Ke = n.object({
  "@type": n.literal("MonetaryAmount"),
  value: n.number().optional(),
  minValue: n.number().optional(),
  maxValue: n.number().optional(),
  currency: n.string()
}).refine(
  ({ maxValue: e, minValue: t, value: i }) => typeof e > "u" && typeof t > "u" && typeof i == "number" || typeof e == "number" && typeof t == "number" && typeof i > "u",
  {
    message: "Either both `minValue` and `maxValue` or only `value` have to be defined"
  }
), U = Ke;
function fe(e) {
  const t = U.safeParse(e);
  return t.success, t.success;
}
const Je = n.object({
  "@type": n.literal("DefinedRegion"),
  addressCountry: n.string().nonempty(),
  addressRegion: n.string().nonempty().optional()
}), B = Je;
function Xe(e) {
  const t = B.safeParse(e);
  return t.success, t.success;
}
const Ye = n.object({
  "@type": n.literal("QuantitativeValue"),
  minValue: n.number(),
  maxValue: n.number(),
  unitCode: n.string()
}).transform((e, t) => {
  switch (e.unitCode) {
    case "min":
    case "minutes": {
      e.unitCode = "min";
      break;
    }
    case "h":
    case "hours": {
      e.unitCode = "h";
      break;
    }
    case "days":
    case "d": {
      e.unitCode = "d";
      break;
    }
    case "wk":
    case "weeks": {
      e.unitCode = "wk";
      break;
    }
    default: {
      t.addIssue({
        fatal: !0,
        path: t.path,
        code: "invalid_enum_value",
        received: e.unitCode,
        options: ["minutes", "hours", "d", "weeks"]
      });
      break;
    }
  }
  return e;
}), z = Ye;
function nn(e) {
  const t = z.safeParse(e);
  return t.success, t.success;
}
function oe(e) {
  const t = z.safeParse(e);
  if (t.success)
    return t.data;
}
const Ze = n.enum([
  "Monday",
  "https://schema.org/Monday",
  "Tuesday",
  "https://schema.org/Tuesday",
  "Wednesday",
  "https://schema.org/Wednesday",
  "Thursday",
  "https://schema.org/Thursday",
  "Friday",
  "https://schema.org/Friday",
  "Saturday",
  "https://schema.org/Saturday",
  "Sunday",
  "https://schema.org/Sunday"
]), de = Ze;
function rn(e) {
  const t = de.safeParse(e);
  return t.success, t.success;
}
const et = n.object({
  "@type": n.literal("ShippingDeliveryTime"),
  cutoffTime: n.string().nonempty().optional(),
  handlingTime: z.optional(),
  transitTime: z.optional(),
  businessDays: n.object({
    "@type": n.literal("OpeningHoursSpecification"),
    dayOfWeek: de.array()
  })
}), le = et;
function tt(e) {
  const t = le.safeParse(e);
  return t.success, t.success;
}
const nt = n.object({
  "@type": n.literal("OfferShippingDetails"),
  shippingSettingsLink: n.string(),
  deliveryTime: le.optional(),
  shippingRate: U,
  shippingDestination: B
}), ge = nt;
function it(e) {
  const t = ge.safeParse(e);
  return t.success, t.success;
}
const rt = n.object({
  "@type": n.literal("Offer"),
  price: n.number(),
  name: n.string().optional(),
  priceCurrency: n.string(),
  availability: q,
  shippingDetails: ge.optional()
}), H = rt;
function sn(e) {
  const t = H.safeParse(e);
  return t.success, t.success;
}
const st = n.object({
  "@type": n.literal("SizeSpecification"),
  name: n.string().nonempty(),
  sizeSystem: n.string().nonempty().optional(),
  sizeGroup: n.string().nonempty().optional()
}), ot = n.object({
  "@type": n.literal("ProductModel"),
  sku: n.string().nonempty(),
  name: n.string().nonempty(),
  mpn: n.string().nonempty().optional(),
  gtin13: n.string().nonempty().optional(),
  size: n.union([n.string().nonempty(), st]).optional(),
  image: n.string().array().nonempty().optional(),
  color: n.string().nonempty().optional(),
  offers: H,
  url: n.string()
}).refine(
  (e) => !(typeof e.size > "u" && typeof e.color > "u"),
  {
    message: "Both `size` and `color` cannot be undefined simultaneously on a product model"
  }
), G = ot;
function on(e) {
  return G.safeParse(e).success;
}
function at(e) {
  if (typeof e > "u")
    return;
  const t = G.safeParse(e);
  if (t.success)
    return t.data;
}
const ut = n.object({
  "@type": n.literal("AggregateOffer"),
  lowPrice: n.number(),
  highPrice: n.number(),
  name: n.string().optional(),
  priceCurrency: n.string(),
  availability: q
}), me = ut;
function an(e) {
  const t = me.safeParse(e);
  return t.success, t.success;
}
const ct = n.object({
  "@type": n.literal("AggregateRating"),
  ratingValue: n.union([n.number(), n.string()]),
  bestRating: n.union([n.number(), n.string()]).optional(),
  worstRating: n.union([n.number(), n.string()]).optional(),
  ratingCount: n.number().int().positive().optional(),
  reviewCount: n.number().int().positive().optional()
}), _ = ct;
function un(e) {
  return _.safeParse(e).success;
}
function cn(e) {
  const t = _.safeParse(e);
  if (t.success)
    return t.data;
}
const pt = n.object({
  "@type": n.literal("Rating"),
  ratingValue: n.union([n.number(), n.string()]),
  bestRating: n.union([n.number(), n.string()]).optional(),
  worstRating: n.union([n.number(), n.string()]).optional(),
  author: n.union([
    n.object({
      "@type": n.literal("Person"),
      name: n.string()
    }),
    n.object({
      "@type": n.literal("Organization"),
      name: n.string()
    })
  ]).optional()
}), K = pt;
function pn(e) {
  return K.safeParse(e).success;
}
function fn(e) {
  const t = K.safeParse(e);
  if (t.success)
    return t.data;
}
const ft = n.object({
  "@type": n.literal("Review"),
  reviewBody: n.string().optional(),
  reviewRating: K.optional(),
  author: n.union([
    n.object({
      "@type": n.literal("Person"),
      name: n.string()
    }),
    n.object({
      "@type": n.literal("Organization"),
      name: n.string()
    })
  ]).optional(),
  datePublished: n.string().optional(),
  name: n.string().optional(),
  description: n.string().optional(),
  reviewAspect: n.string().optional(),
  positiveNotes: n.string().optional(),
  negativeNotes: n.string().optional()
}), J = ft;
function dn(e) {
  return J.safeParse(e).success;
}
function ln(e) {
  const t = J.safeParse(e);
  if (t.success)
    return t.data;
}
const dt = n.object({
  "@type": n.literal("MerchantReturnPolicy"),
  applicableCountry: n.string().optional(),
  returnPolicyCategory: n.enum([
    "MerchantReturnFiniteReturnWindow",
    "MerchantReturnNotPermitted",
    "MerchantReturnUnlimitedWindow",
    "MerchantReturnUnspecified"
  ]).optional(),
  merchantReturnDays: n.number().min(0).optional(),
  returnMethod: n.enum(["ReturnAtKiosk", "ReturnByMail", "ReturnInStore"]).optional(),
  returnFees: n.enum([
    "FreeReturn",
    "ReturnFeesCustomerResponsibility",
    "ReturnShippingFees"
  ]).optional(),
  inStoreReturnsOffered: n.boolean().optional()
}), ye = dt;
function gn(e) {
  const t = ye.safeParse(e);
  return t.success, t.success;
}
const lt = n.object({
  "@type": n.literal("Brand"),
  name: n.string().nonempty()
}), gt = lt, mt = n.object({
  "@type": n.literal("Product"),
  sku: n.string().nonempty(),
  name: n.string().nonempty(),
  description: n.string().nonempty().optional(),
  image: n.string().array().nonempty().optional(),
  brand: gt.optional(),
  gtin13: n.string().nonempty().optional(),
  offers: H.or(me),
  model: n.array(G).nonempty().optional(),
  url: n.string(),
  aggregateRating: _.optional(),
  review: n.array(J).optional(),
  hasMerchantReturnPolicy: ye.optional()
}).refine(
  (e) => {
    var t;
    return !(typeof e.model < "u" && ((t = e.offers) == null ? void 0 : t["@type"]) === "Offer");
  },
  {
    message: "If `model` is defined, `offers` need to be of type 'AggregateOffer'"
  }
).refine(
  (e) => {
    var t;
    return !(typeof e.model > "u" && ((t = e.offers) == null ? void 0 : t["@type"]) === "AggregateOffer");
  },
  {
    message: "If `model` is undefined, `offers` need to be of type 'Offer'"
  }
).refine(
  (e) => !(typeof e.model > "u" && typeof e.offers > "u"),
  { message: "Both `model` and `offers` cannot be undefined simultaneously" }
), X = mt;
function yt(e) {
  return X.safeParse(e).success;
}
function ht(e) {
  const t = X.safeParse(e);
  if (t.success)
    return t.data;
}
const bt = n.object({
  "@type": n.literal("ItemList"),
  itemListElement: n.array(
    n.object({
      "@type": n.literal("ListItem"),
      position: n.number(),
      item: X
    })
  )
}), he = bt;
function St(e) {
  return he.safeParse(e).success;
}
function mn(e) {
  const t = he.safeParse(e);
  if (t.success)
    return t.data;
}
const be = a.object({
  applicableCountry: a.string().optional(),
  returnPolicyCategory: a.enum([
    "MerchantReturnFiniteReturnWindow",
    "MerchantReturnNotPermitted",
    "MerchantReturnUnlimitedWindow",
    "MerchantReturnUnspecified"
  ]).optional(),
  merchantReturnDays: a.number().min(0).optional(),
  returnMethod: a.enum(["ReturnAtKiosk", "ReturnByMail", "ReturnInStore"]).optional(),
  returnFees: a.enum([
    "FreeReturn",
    "ReturnFeesCustomerResponsibility",
    "ReturnShippingFees"
  ]).optional(),
  inStoreReturnsOffered: a.boolean().optional()
});
function yn(e) {
  return be.safeParse(e).success;
}
const Se = be.array().nonempty();
function vt(e) {
  return Se.safeParse(e).success;
}
function hn(e, t) {
  const i = Se.safeParse(e);
  if (!i.success) {
    t == null || t(i.error);
    return;
  }
  return i.data;
}
const Pt = (e) => {
  const { country: t, baseUrl: i } = R();
  return S(() => {
    var u, c, o, r, p, d;
    return vt(e) ? {
      "@type": "MerchantReturnPolicy",
      applicableCountry: ((u = e == null ? void 0 : e[0]) == null ? void 0 : u.applicableCountry) || t,
      returnPolicyCategory: (c = e == null ? void 0 : e[0]) == null ? void 0 : c.returnPolicyCategory,
      merchantReturnDays: (o = e == null ? void 0 : e[0]) == null ? void 0 : o.merchantReturnDays,
      returnMethod: (r = e == null ? void 0 : e[0]) == null ? void 0 : r.returnMethod,
      returnFees: (p = e == null ? void 0 : e[0]) == null ? void 0 : p.returnFees,
      inStoreReturnsOffered: (d = e == null ? void 0 : e[0]) == null ? void 0 : d.inStoreReturnsOffered
    } : void 0;
  }, [e, t, i]);
}, ae = a.object({
  unit: a.enum(["days", "hours", "minutes", "seconds"]),
  endTime: a.number(),
  startTime: a.number(),
  isEnabled: a.boolean()
}), ve = a.object({
  cutoffTime: a.string().optional(),
  handlingTime: ae,
  transitTime: ae
});
function bn(e) {
  const t = ve.safeParse(e);
  return t.success || console.warn(
    "Failed to parse type shippingDeliveryTimeSettingSchema: ",
    t.error
  ), t.success;
}
const Pe = a.object({
  countries: a.string().array().nonempty(),
  deliveryTime: ve.array().min(1).max(1).optional(),
  region: a.string().optional(),
  shippingRateMin: a.string(),
  shippingRateMax: a.string(),
  freeShippingThreshold: a.string().optional(),
  shippingSettingsLink: a.object({
    href: a.string()
  }).optional()
});
function Sn(e) {
  return Pe.safeParse(e).success;
}
const Re = Pe.array().nonempty();
function j(e) {
  return Re.safeParse(e).success;
}
function vn(e, t) {
  const i = Re.safeParse(e);
  if (!i.success) {
    t == null || t(i.error);
    return;
  }
  return i.data;
}
const Rt = (e) => {
  const { country: t, currencyCode: i } = R();
  return S(() => {
    if (!j(e))
      return;
    const s = /* @__PURE__ */ new Map();
    for (const u of e) {
      if (!u.countries.includes(t))
        continue;
      const c = u.countries.join("");
      if (s.has(c)) {
        console.warn(`Duplicate key ${c} in StructuredDataShippingRate`);
        continue;
      }
      let o = parseInt(
        u.shippingRateMin
      );
      isNaN(o) && (o = void 0);
      let r = parseInt(
        u.shippingRateMax
      );
      isNaN(r) && (r = void 0);
      let p;
      typeof o == "number" && typeof r == "number" && (p = {
        "@type": "MonetaryAmount",
        minValue: o,
        maxValue: r,
        currency: i
      }), fe(p) && s.set(c, p);
    }
    if (s.size !== 0)
      return s;
  }, [e, t, i]);
}, wt = (e) => {
  const { country: t } = R();
  return S(() => {
    if (!j(e))
      return;
    const i = /* @__PURE__ */ new Map();
    for (const s of e) {
      if (!s.countries.includes(t))
        continue;
      const u = s.countries.join("");
      if (i.has(u)) {
        console.warn(`Duplicate key ${u} in StructuredDataShippingRate`);
        continue;
      }
      const c = {
        "@type": "DefinedRegion",
        addressCountry: t
      };
      typeof s.region == "string" && s.region.length > 0 && (c.addressRegion = s.region), Xe(c) && i.set(u, c);
    }
    if (i.size !== 0)
      return i;
  }, [e, t]);
}, Ot = (e) => {
  const { country: t } = R();
  return S(() => {
    var s;
    if (!j(e))
      return;
    const i = /* @__PURE__ */ new Map();
    for (const u of e) {
      if (!u.countries.includes(t))
        continue;
      const c = u.countries.join("");
      if (i.has(c)) {
        console.warn(`Duplicate key ${c} in StructuredDataShippingRate`);
        continue;
      }
      if (typeof u > "u" || !Array.isArray(u.deliveryTime) || typeof u.deliveryTime[0] > "u")
        continue;
      const [o] = u.deliveryTime, r = {
        "@type": "ShippingDeliveryTime",
        businessDays: {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: [
            "https://schema.org/Monday",
            "https://schema.org/Tuesday",
            "https://schema.org/Wednesday",
            "https://schema.org/Thursday",
            "https://schema.org/Friday"
          ]
        }
      };
      if (o.handlingTime.isEnabled === !0 && (r.handlingTime = {
        "@type": "QuantitativeValue",
        minValue: o.handlingTime.startTime,
        maxValue: o.handlingTime.endTime,
        unitCode: o.handlingTime.unit
      }, r.handlingTime = oe(r.handlingTime)), o.transitTime.isEnabled === !0 && (r.transitTime = {
        "@type": "QuantitativeValue",
        minValue: o.transitTime.startTime,
        maxValue: o.transitTime.endTime,
        unitCode: o.transitTime.unit
      }, r.transitTime = oe(r.transitTime)), typeof o.cutoffTime == "string" && /(([0-1][0-9])|(2[0-3])):[0-5][0-9]/.test(o.cutoffTime)) {
        const [p, d] = o.cutoffTime.split(
          ":"
        );
        let m = parseInt(p);
        (isNaN(m) || m > 23 || m < 0) && (m = void 0);
        let l = parseInt(d);
        if ((isNaN(l) || l > 59 || l < 0) && (l = void 0), typeof m < "u") {
          const g = /* @__PURE__ */ new Date();
          g.setUTCHours(m, l ?? 0, 0, 0), r.cutoffTime = (s = g.toJSON().split("T")) == null ? void 0 : s[1];
        }
      }
      Object.values(r ?? {}).filter((p) => typeof p < "u").length < 1 || tt(r) && i.set(c, r);
    }
    if (i.size !== 0)
      return i;
  }, [e, t]);
}, Y = (e) => {
  const t = Rt(
    e
  ), i = wt(
    e
  ), s = Ot(
    e
  ), { country: u, baseUrl: c } = R();
  return S(() => {
    if (!j(e) || typeof i > "u" || typeof t > "u" || typeof s > "u")
      return;
    const o = /* @__PURE__ */ new Map();
    for (const r of e) {
      if (!r.countries.includes(u))
        continue;
      const p = r.countries.join("");
      if (o.has(p)) {
        console.warn(`Duplicate key ${p} in OfferShippingDetails`);
        continue;
      }
      const d = t.get(p), m = i.get(p), l = s.get(p);
      if (typeof d > "u" || typeof m > "u" || typeof l > "u")
        return;
      const g = r == null ? void 0 : r.shippingSettingsLink, b = {
        "@type": "OfferShippingDetails",
        shippingDestination: m,
        deliveryTime: l,
        // @ts-expect-error - setting shippingRate to undefined is intentional
        shippingRate: void 0
      };
      g && (b.shippingSettingsLink = `${c}${g.href}`), fe(d) && (b.shippingRate = d), it(b) && o.set(p, b);
    }
    if (o.size !== 0)
      return o;
  }, [
    e,
    t,
    i,
    s,
    u,
    c
  ]);
};
function ue(e) {
  if (typeof e != "string")
    return !1;
  try {
    new URL(e);
  } catch {
    return !1;
  }
  return !0;
}
function ce(e, t, i, s, u = !0, c, o) {
  var te, ne, ie, I, re;
  const r = {
    "@type": "Product",
    name: e.name
  }, p = e.sku, d = e.name, m = e.description, l = e.countryOfOrigin, g = e.priceAsNumber, b = e.brandName, A = (te = e.imageUrls) == null ? void 0 : te.filter((f) => ue(f)), E = e.urlSlug;
  if (typeof p > "u") {
    console.warn(
      `[useStructuredDataProduct]: Invalid sku for product, got ${p}. Product object: `,
      e
    );
    return;
  }
  let O = 1 / 0, M = 0;
  for (let f = 0; f < e.variants.length; ++f) {
    const h = e.variants[f];
    if (typeof h > "u")
      continue;
    const v = {
      "@type": "ProductModel"
    }, C = h.sku, L = h.size, W = h.ean, F = h.priceAsNumber ?? g;
    let x = (ne = h.imageUrls) == null ? void 0 : ne.filter((je) => ue(je));
    if (typeof x > "u" && (x = A), typeof C == "string" && C.length > 0)
      v.sku = C;
    else {
      console.warn(
        `[useStructuredDataProduct]: Invalid sku for variant, got ${C}. Variant object: `,
        h
      );
      continue;
    }
    typeof d == "string" && d.length > 0 && (v.name = d), typeof L == "string" && L.length > 0 && (typeof h.sizeSystem == "string" && h.sizeSystem.length > 0 ? v.size = {
      "@type": "SizeSpecification",
      name: L,
      sizeSystem: h.sizeSystem
    } : v.size = L), typeof W == "string" && W.length > 0 && (v.gtin13 = W), a.string().nonempty().array().nonempty().safeParse(x).success && (v.image = x), typeof t == "string" && t.length > 0 && typeof F == "number" && typeof h.quantity == "number" && (v.offers = {
      "@type": "Offer",
      price: F,
      priceCurrency: t,
      availability: h.quantity > 0 ? "InStock" : "OutOfStock",
      ...o && { shippingDetails: o }
    }, O = Math.min(O, F), M = Math.max(O, F));
    const Q = h.urlSlug ?? e.urlSlug;
    typeof i == "string" && i.length > 0 && typeof Q == "string" && Q.length > 0 && (v.url = `${i}/${s}/${Q}`);
    const se = at(v);
    typeof se > "u" || (r.model = [
      se,
      ...r.model ?? []
    ]);
  }
  if (typeof b == "string" && b.length > 0 && (r.brand = {
    "@type": "Brand",
    name: b
  }), e.variants.length === 1) {
    const f = (ie = e.variants[0]) == null ? void 0 : ie.ean;
    typeof f == "string" && f.length > 0 && (r.gtin13 = f);
  }
  typeof p == "string" && p.length > 0 && (r.sku = p), typeof d == "string" && d.length > 0 && (r.name = d), typeof m == "string" && m.length > 0 && (r.description = m), typeof t == "string" && t.length > 0 && typeof r.model < "u" && (typeof g == "number" || typeof O == "number" && typeof M == "number") ? r.offers = {
    "@type": "AggregateOffer",
    lowPrice: typeof O == "number" ? O : g,
    highPrice: typeof M == "number" ? M : g,
    priceCurrency: t,
    availability: r.model.some(
      (f) => f.offers.availability === "InStock"
    ) ? "InStock" : "OutOfStock"
  } : typeof r.model > "u" && typeof t == "string" && t.length > 0 && typeof g == "number" && (r.offers = {
    "@type": "Offer",
    price: g,
    priceCurrency: t,
    availability: (re = (I = e.variants) == null ? void 0 : I.some) != null && re.call(
      I,
      (f) => typeof (f == null ? void 0 : f.quantity) == "number" && (f == null ? void 0 : f.quantity) > 0
    ) ? "InStock" : "OutOfStock",
    ...o && { shippingDetails: o }
  }), typeof i == "string" && i.length > 0 && typeof E == "string" && E.length > 0 && (r.url = `${i}/${s}/${E}`), typeof A < "u" && a.string().array().nonempty().safeParse(A).success && (r.image = A), typeof l == "string" && l.length > 0 && (r.countryOfOrigin = {
    "@type": "Country",
    name: l
  });
  const T = u ? e.aggregateRating : void 0, V = u ? e.reviews : void 0;
  return T && (r.aggregateRating = {
    "@type": "AggregateRating",
    ratingValue: T.ratingValue,
    bestRating: T.bestRating,
    worstRating: T.worstRating,
    reviewCount: T.reviewCount,
    ratingCount: T.ratingCount
  }), V && V.length > 0 && (r.review = V.map((f) => ({
    "@type": "Review",
    reviewBody: f.reviewBody,
    reviewRating: f.reviewRating ? {
      "@type": "Rating",
      ratingValue: f.reviewRating.ratingValue,
      bestRating: f.reviewRating.bestRating,
      worstRating: f.reviewRating.worstRating
    } : void 0,
    author: f.author ? {
      "@type": f.author.type,
      name: f.author.name
    } : void 0,
    datePublished: f.datePublished,
    name: f.name,
    description: f.description,
    reviewAspect: f.reviewAspect,
    positiveNotes: f.positiveNotes,
    negativeNotes: f.negativeNotes
  }))), c && (r.hasMerchantReturnPolicy = c), ht(r);
}
function we(e) {
  const { currencyCode: t, baseUrl: i, siteSlug: s, country: u } = R(), c = He(), o = qe(), r = Pt(
    c
  ), p = Y(
    o
  ), d = u, m = p == null ? void 0 : p.get(d);
  return S(() => {
    if (!(typeof e > "u" || typeof t > "u" || typeof i > "u" || typeof s > "u"))
      if (Array.isArray(e)) {
        if (e.length === 0)
          return;
        const l = {
          "@type": "ItemList",
          itemListElement: []
        };
        for (let g = 0; g < e.length; ++g) {
          const b = e[g];
          typeof b > "u" || l.itemListElement.push({
            "@type": "ListItem",
            position: g + 1,
            item: ce(
              b,
              t,
              i,
              s,
              !1,
              // Don't include reviews for product lists
              r,
              m
            )
          });
        }
        return St(l) ? l : void 0;
      } else
        return ce(
          e,
          t,
          i,
          s,
          !0,
          // Include reviews for single product (PDP)
          r,
          m
        );
  }, [
    e,
    t,
    i,
    s,
    r,
    m
  ]);
}
const Tt = ({
  unformattedProducts: e
}) => {
  const t = we(e), i = Ie(0);
  return Ce(() => {
    i.current += 1;
  }, [t]), typeof t > "u" ? null : /* @__PURE__ */ y(
    D,
    {
      item: {
        "@context": "https://schema.org",
        ...t
      }
    },
    i.current
  );
}, kt = ({ settings: e }) => {
  const t = Y(e);
  return /* @__PURE__ */ y($, { children: [...(t == null ? void 0 : t.entries()) ?? []].map(
    ([i, s]) => /* @__PURE__ */ y(
      D,
      {
        item: {
          "@context": "https://schema.org",
          ...s
        }
      },
      i
    )
  ) });
}, Dt = n.object({
  "@type": n.literal("ShippingRateSettings"),
  shippingRate: U,
  freeShippingThreshold: U,
  shippingDestination: B
}), Oe = Dt;
function jt(e) {
  const t = Oe.safeParse(e);
  return t.success, t.success;
}
function Pn(e) {
  const t = Oe.safeParse(e);
  if (t.success)
    return t.data;
}
const At = ({ settings: e }) => {
  const { country: t, currencyCode: i, currentPath: s } = R(), u = Y(e), c = S(() => {
    var r;
    if (!j(e) || typeof u > "u")
      return;
    const o = /* @__PURE__ */ new Map();
    for (const p of e) {
      if (!p.countries.includes(t))
        continue;
      const d = p.countries.join(""), m = u.get(d);
      if (typeof m > "u" || ((r = p.shippingSettingsLink) == null ? void 0 : r.href) !== s)
        continue;
      const l = {
        ...m,
        "@type": "ShippingRateSettings"
      };
      if (delete l.deliveryTime, delete l.shippingSettingsLink, typeof p.freeShippingThreshold == "string") {
        let g = parseFloat(
          p.freeShippingThreshold
        );
        isNaN(g) && (g = void 0), typeof g < "u" && (l.freeShippingThreshold = {
          "@type": "MonetaryAmount",
          value: g,
          currency: i
        });
      }
      if (o.has(d)) {
        console.warn(`Duplicate key ${d} in ShippingRateSettings`);
        continue;
      }
      jt(l) && o.set(d, l);
    }
    if (o.size !== 0)
      return o;
  }, [u, e]);
  return /* @__PURE__ */ y($, { children: [...(c == null ? void 0 : c.entries()) ?? []].map(
    ([o, r]) => /* @__PURE__ */ y(
      D,
      {
        item: {
          "@context": "https://schema.org",
          ...r
        }
      },
      o
    )
  ) });
}, Rn = ({
  offerShippingDetailsSettings: e
}) => {
  const t = $e(), i = We();
  return /* @__PURE__ */ Ae($, { children: [
    Object.entries(i).filter(([s]) => !(typeof t < "u" && s === k.ProductList)).map(([, s]) => s),
    /* @__PURE__ */ y(Ge, {}),
    /* @__PURE__ */ y(kt, { settings: e }),
    /* @__PURE__ */ y(
      At,
      {
        settings: e
      }
    ),
    /* @__PURE__ */ y(Tt, { unformattedProducts: t })
  ] });
}, Mt = n.object({
  "@type": n.literal("FAQPage"),
  mainEntity: n.array(
    n.object({
      "@type": n.literal("Question"),
      name: n.string(),
      acceptedAnswer: n.object({
        "@type": n.literal("Answer"),
        text: n.string()
      })
    })
  ).nonempty()
}), It = Mt;
function Ct(e) {
  const t = It.safeParse(e);
  return t.success, t.success;
}
const Z = (e, t) => {
  const i = Qe(), s = Le();
  Fe(
    () => {
      if (typeof e > "u")
        return;
      const u = `schema-org-script-${e.name ?? e["@type"] ?? t}-${s}`, c = /* @__PURE__ */ y(
        D,
        {
          item: {
            "@context": "https://schema.org",
            ...e
          }
        },
        u
      );
      i(t, c);
    },
    {
      ifDefined: [e]
    }
  );
}, Lt = (e) => {
  if (e.length === 0)
    return;
  const t = {
    "@type": "FAQPage"
  };
  let i = [];
  for (const { q: s, a: u } of e) {
    if (typeof s != "string" || typeof u != "string") {
      console.warn("[useInjectFAQPage]: Wrong input, got", { q: s, a: u });
      continue;
    }
    i = [
      ...i,
      {
        "@type": "Question",
        name: s,
        acceptedAnswer: {
          "@type": "Answer",
          text: u
        }
      }
    ];
  }
  if (t.mainEntity = i, !Ct(t)) {
    console.warn(
      "[useInjectFAQPage]: Could not generate FAQ Page structured data from: ",
      e,
      " generated: ",
      t,
      ", which is not valid SchemaOrg format"
    );
    return;
  }
  return t;
}, wn = (e) => {
  const t = S(() => {
    if (!(typeof e > "u"))
      return Lt(e);
  }, [e]);
  Z(t, k.FAQPage);
}, On = (e) => {
  const t = we(e);
  Z(
    t,
    yt(t) ? k.Product : k.ProductList
  );
}, Ft = n.object({
  "@type": n.literal("SearchAction"),
  target: n.object({
    "@type": n.literal("EntryPoint"),
    urlTemplate: n.string()
  }),
  "query-input": n.string()
}), Te = Ft;
function Tn(e) {
  return Te.safeParse(e).success;
}
const xt = n.object({
  "@type": n.literal("ImageObject"),
  url: n.string(),
  contentUrl: n.string().optional(),
  caption: n.string().optional(),
  inLanguage: n.string().optional()
}), ke = xt;
function kn(e) {
  return ke.safeParse(e).success;
}
const Ut = n.object({
  "@type": n.literal("WebSite"),
  "@context": n.literal("https://schema.org/"),
  url: n.string(),
  name: n.string(),
  description: n.string().optional(),
  inLanguage: n.string().optional(),
  keywords: n.string().optional(),
  potentialAction: Te.optional(),
  logo: ke.optional(),
  sameAs: n.array(n.string()).optional()
}), zt = Ut;
function Nt(e) {
  return zt.safeParse(e).success;
}
const Et = (e) => {
  const t = {
    "@type": "WebSite",
    "@context": "https://schema.org/",
    url: e.url,
    name: e.name
  };
  if (e.description && (t.description = e.description), e.inLanguage && (t.inLanguage = e.inLanguage), e.keywords && (t.keywords = e.keywords), e.searchActionUrlTemplate && (t.potentialAction = {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: e.searchActionUrlTemplate
    },
    "query-input": "required name=search_term_string"
  }), e.logoUrl && (t.logo = {
    "@type": "ImageObject",
    url: e.logoUrl,
    contentUrl: e.logoUrl
  }, e.logoCaption && (t.logo.caption = e.logoCaption), e.logoLanguage && (t.logo.inLanguage = e.logoLanguage)), e.sameAs && e.sameAs.length > 0 && (t.sameAs = e.sameAs), !Nt(t)) {
    console.warn(
      "[useInjectWebSite]: Could not generate WebSite structured data from: ",
      e,
      " generated: ",
      t,
      ", which is not valid SchemaOrg format"
    );
    return;
  }
  return t;
}, Dn = (e) => {
  const t = S(() => {
    if (!(typeof e > "u"))
      return Et(e);
  }, [e]);
  Z(t, k.WebSite);
}, Vt = n.object({
  a: n.string(),
  q: n.string()
}), De = n.object({
  qa: n.array(Vt)
});
function jn(e) {
  return De.safeParse(e).success;
}
function An(e) {
  const t = De.safeParse(e);
  if (t.success)
    return t.data;
}
const Mn = n.object({
  name: n.string(),
  description: n.string().optional(),
  keywords: n.string().optional(),
  logoUrl: n.string(),
  logoCaption: n.string().optional(),
  sameAs: n.string().optional()
}), Wt = a.object({
  sku: a.string(),
  name: a.string(),
  uri: a.string(),
  excerpt: a.string().optional(),
  brand: a.string().optional(),
  brandName: a.string().nullish(),
  countryOrigin: a.string().optional().nullable(),
  price: a.object({
    priceAsNumber: a.number()
  }),
  mediaUrls: a.array(a.string()),
  frontendItems: a.array(
    a.object({
      sku: a.string(),
      name: a.string(),
      ean: a.string().optional(),
      quantity: a.number().optional()
    })
  )
});
function Qt(e) {
  const t = Wt.safeParse(e);
  return t.success || console.warn(
    "Type validation of StructuredDataFormattableCentraProduct failed: ",
    t.error
  ), t.success;
}
function In(e) {
  if (!(typeof e > "u") && Qt(e))
    return {
      sku: e.sku,
      name: e.name,
      description: e.excerpt,
      brandName: e.brandName ?? void 0,
      priceAsNumber: e.price.priceAsNumber,
      imageUrls: e.mediaUrls,
      countryOfOrigin: e.countryOrigin,
      urlSlug: e.uri,
      variants: e.frontendItems.map((t) => ({
        sku: t.sku,
        size: t.name,
        ean: t.ean,
        imageUrls: e.mediaUrls,
        quantity: t.quantity
      }))
    };
}
function Cn(e) {
  switch (e.dataModel) {
    case "simple":
      return $t(e);
    case "with_variants":
      return qt(e);
    case "bundle":
      return Bt(e);
    default:
      throw new Error("Unsupported product type" + e.dataModel);
  }
}
function $t(e) {
  const t = ee(e);
  return {
    sku: e.sku,
    name: e.base.content.name,
    description: e.base.content.description,
    brandName: e.base.content.brand,
    priceAsNumber: e.priceInfo.price.number,
    imageUrls: t,
    urlSlug: e.base.slug,
    variants: [
      {
        sku: e.sku,
        size: "One size",
        ean: e.ean,
        imageUrls: t,
        quantity: e.inventory.quantity
      }
    ]
  };
}
function qt(e) {
  var i;
  const t = ee(e);
  return {
    sku: e.base.productId,
    name: e.base.content.name,
    description: e.base.content.description,
    brandName: e.base.content.brand,
    priceAsNumber: (i = e.variants[0]) == null ? void 0 : i.priceInfo.price.number,
    imageUrls: t,
    urlSlug: e.base.slug,
    variants: e.variants.map((s) => ({
      sku: s.sku,
      size: s.label,
      ean: s.ean,
      imageUrls: t,
      quantity: s.inventory.quantity
    }))
  };
}
function Bt(e) {
  const t = ee(e);
  return {
    sku: e.bundlePurchaseInfo.sku,
    name: e.base.content.name,
    description: e.base.content.description,
    brandName: e.base.content.brand,
    priceAsNumber: e.bundlePurchaseInfo.priceInfo.price.number,
    imageUrls: t,
    urlSlug: e.base.slug,
    variants: [
      {
        sku: e.bundlePurchaseInfo.sku,
        size: "Bundle",
        imageUrls: t,
        quantity: e.bundlePurchaseInfo.inventory.quantity
      }
    ]
  };
}
function ee(e) {
  return e.base.content.media.filter(xe).map((t) => t.src);
}
export {
  Ve as GearsStructuredDataContextProvider,
  Rn as GearsStructuredDataHeadTag,
  Ge as StructuredDataBreadcrumbs,
  Tt as StructuredDataProducts,
  Zt as StructuredDataProvider,
  k as StructuredDataScriptName,
  kt as StructuredDataShippingDetails,
  At as StructuredDataShippingRateSettings,
  me as aggregateOfferSchema,
  _ as aggregateRatingSchema,
  gt as brandSchema,
  ze as breadcrumbListSchema,
  de as dayOfWeekSchema,
  In as defaultMapCentraProductToStructuredDataProduct,
  B as definedRegionSchema,
  It as faqPageSchema,
  Cn as greaseProductToUnformattedStructuredDataProduct,
  ke as imageObjectSchema,
  an as isAggregateOffer,
  un as isAggregateRating,
  Ne as isBreadcrumbList,
  rn as isDayOfWeek,
  Xe as isDefinedRegion,
  Ct as isFAQPage,
  kn as isImageObject,
  tn as isItemAvailability,
  gn as isMerchantReturnPolicy,
  vt as isMerchantReturnPolicySettings,
  yn as isMerchantReturnPolicySettingsEntry,
  fe as isMonetaryAmount,
  sn as isOffer,
  it as isOfferShippingDetails,
  j as isOfferShippingDetailsSettings,
  Sn as isOfferShippingDetailsSettingsEntry,
  yt as isProduct,
  St as isProductList,
  on as isProductModel,
  nn as isQuantitativeValue,
  pn as isRating,
  dn as isReview,
  Tn as isSearchAction,
  tt as isShippingDeliveryTime,
  bn as isShippingDeliveryTimeSetting,
  jt as isShippingRateSettings,
  jn as isStoryblokFAQPage,
  Nt as isWebSite,
  q as itemAvailabilitySchema,
  ye as merchantReturnPolicySchema,
  be as merchantReturnPolicySettingsEntrySchema,
  Se as merchantReturnPolicySettingsSchema,
  U as monetaryAmountSchema,
  H as offerSchema,
  ge as offerShippingDetailsSchema,
  Pe as offerShippingDetailsSettingsEntrySchema,
  Re as offerShippingDetailsSettingsSchema,
  he as productListSchema,
  G as productModelSchema,
  X as productSchema,
  z as quantitativeValueSchema,
  K as ratingSchema,
  J as reviewSchema,
  Te as searchActionSchema,
  le as shippingDeliveryTimeSchema,
  ve as shippingDeliveryTimeSettingSchema,
  Oe as shippingRateSettingsSchema,
  ae as storyblokTimeRangeFieldTypeSchema,
  w as structuredDataContext,
  cn as toAggregateRatingOrUndefined,
  hn as toMerchantReturnPolicySettingsOrUndefined,
  vn as toOfferShippingDetailsSettingsOrUndefined,
  mn as toProductListOrUndefined,
  at as toProductModelOrUndefined,
  ht as toProductOrUndefined,
  oe as toQuantitativeValueOrUndefined,
  fn as toRatingOrUndefined,
  ln as toReviewOrUndefined,
  Pn as toShippingRateSettingsOrUndefined,
  An as toStoryblokFAQPageOrUndefined,
  Qe as useAddGearsStructuredDataHeadTagScript,
  Be as useBreadCrumbs,
  We as useGearsStructuredDataHeadTagScripts,
  wn as useInjectFAQPage,
  On as useInjectStructuredDataProducts,
  Dn as useInjectWebSite,
  He as useMerchantReturnPolicySettings,
  $e as usePdpProduct,
  Yt as useRemoveGearsStructuredDataHeadTagScript,
  qe as useShippingDetailsSettings,
  R as useStructuredDataContext,
  Z as useStructuredDataInjector,
  en as useStructuredDataMappers,
  Pt as useStructuredDataMerchantReturnPolicy,
  Y as useStructuredDataOfferShippingDetails,
  we as useStructuredDataProduct,
  Ot as useStructuredDataShippingDeliveryTime,
  wt as useStructuredDataShippingDestination,
  Rt as useStructuredDataShippingRate,
  zt as webSiteSchema,
  Mn as webSiteSettingsSchema
};
